import React from 'react';
import { useSelector } from 'react-redux';

export const UserProfileCard = () => {
    const { user } = useSelector((state) => state.auth);

    return (
        <div className="card">
            <div className="card-body">
                <div className="mb-3 row">
                    <label htmlFor="name" className="col-lg-2 col-form-label">
                        Name
                    </label>
                    <div className="col-lg-10">
                        <input
                            readOnly
                            type="text"
                            name="name"
                            value={user.name}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="email" className="col-lg-2 col-form-label">
                        Email
                    </label>
                    <div className="col-lg-10">
                        <input
                            readOnly
                            type="text"
                            name="email"
                            value={user.email}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
